<template>
  <div>
    <template v-if="column === 'lostBenefit' && currency !== ''">
      <h3>{{ parseFloat(currencyContent.lostBenefit).toFixed(2) }} {{ currency }}</h3>
    </template>
    <template v-if="column === 'percentageOfSummary'">
      <h3>{{ asPercentage(currencyContent.percentageGrossSummaryAll) }}</h3>
    </template>
    <template v-if="column === 'percentageOfCount'">
      <h3>{{ asPercentage(currencyContent.percentageCountAll) }}</h3>
    </template>
    <template v-if="column === 'lostBenefitPercentage' && currency !== ''">
      <h3>{{ parseFloat((currencyContent.lostBenefit / currencyContent.grossSummary) * 100).toFixed(1) }} %</h3>
    </template>
    <template v-if="column === 'count'">
      <h3>
        {{ currencyContent.count }}
      </h3>
    </template>
    <template v-if="column === 'averageTicketPrice' && currency !== ''">
      <h3>{{ parseFloat(currencyContent.grossSummary / currencyContent.count).toFixed(2) }} {{ currency }}</h3>
    </template>
    <template v-if="column === 'fareBase' && currency !== ''">
      <h3>{{ parseFloat(currencyContent.fareBase).toFixed(2) }} {{ currency }}</h3>
    </template>
    <template v-if="column === 'discount' && currency !== ''">
      <h3>{{ parseFloat(currencyContent.discount).toFixed(2) }} {{ currency }}</h3>
    </template>
    <template v-if="column === 'airportCharges' && currency !== ''">
      <h3>{{ parseFloat(currencyContent.airportCharges).toFixed(2) }} {{ currency }}</h3>
    </template>
    <template v-if="column === 'grossSummary' && currency !== ''">
      <h3>
        <span class="datatable-total-amount"> {{ parseFloat(currencyContent.grossSummary).toFixed(2) }} {{ currency }} </span>
      </h3>
    </template>
    <template v-if="column === 'grossSummaryWithDiscount' && currency !== ''">
      <h3>
        <span class="datatable-total-amount"> {{ parseFloat(currencyContent.grossSummaryWithDiscount).toFixed(2) }} {{ currency }} </span>
      </h3>
    </template>
    <template v-if="column === 'netSummary' && currency !== ''">
      <h3>
        <span class="datatable-net-amount"> {{ parseFloat(currencyContent.netSummary).toFixed(2) }} {{ currency }} </span>
      </h3>
    </template>
    <template v-if="column === 'percentageOfOrganizationalUnitCount'">
      <h3>{{ asPercentage(currencyContent.percentageCountOrganizationUnit) }}</h3>
    </template>
    <template v-if="column === 'percentageOfDomesticForeignCount'">
      <h3>{{ asPercentage(currencyContent.percentageCountDomesticForeign) }}</h3>
    </template>
    <template v-if="column === 'percentageOfOrganizationalUnitAmount'">
      <h3>{{ asPercentage(currencyContent.percentageGrossSummaryOrganizationUnit) }}</h3>
    </template>
    <template v-if="column === 'percentageOfDomesticForeignAmount'">
      <h3>{{ asPercentage(currencyContent.percentageGrossSummaryDomesticForeign) }}</h3>
    </template>
  </div>
</template>

<script>
import formatDateView from "../../../repository/fotmatDateView";
import moment from "moment";

export default {
  name: "BookingReportStandardHeaderColumnComponent",
  props: {
    currencyContent: {
      required: true,
      type: Object
    },
    column: {
      required: true,
      type: String
    }
  },
  computed: {
    currency() {
      return this.currencyContent.currency;
    }
  },
  methods: {
    formatDateView: formatDateView,
    localMoment: moment,
    asPercentage(text) {
      return (parseFloat(text) * 100).toFixed(1) + " %";
    }
  }
};
</script>

<style scoped></style>
